import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {goToTimeline} from "../../../actions/transOperationActions";
import {withRouter} from "react-router-dom";
import TimeUtils from "../../../helper/TimeUtils";

class TimeLinePop extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hour:null,
            Minute:null,
            second:null,
            fram:null,
            videoFps:24


        }

    }

    async editTransaction(event) {
        event.preventDefault();
        const {videoFps,frameWidth} = this.props.transOperation;

        const {data} = this.props.editTable;


        let hour,Minute,seconds,fram;

        if(this.state.fram === null){
            fram = 0;
        }else{
            fram = (this.state.fram > videoFps)?videoFps:this.state.fram;
        }

        if(this.state.second === null){
            seconds = 0;
        }else{
            seconds = this.state.second * videoFps;
        }

        if(this.state.Minute === null){
            Minute = 0;
        }else{
            Minute = this.state.Minute * 60  * videoFps;
        }


        if(this.state.hour === null){
            hour = 0;
        }else{
            hour = this.state.hour * 60 * 60 * videoFps;
        }

        await this.setState({fram:null});
        await this.setState({seconds:null});
        await this.setState({Minute:null});
        await this.setState({hour:null});


        let wnat_frame = (parseFloat(fram) + parseFloat(seconds) + parseFloat(Minute) + parseFloat(hour));



        let startSecond = wnat_frame/videoFps;

        let lineNum = TimeUtils.secondsConvertToRowIndew(startSecond,videoFps,data);


        this.props.setDoubleClick(lineNum);

        await this.props.closeAlert();

        this.props.closeTranslationsNavbarAlertView();

    }

    async componentDidMount() {
        await this.setState({videoFps:this.props.transOperation.videoFps});

    }

        render() {

        return (
            <Popup
                open={this.props.isOpen}
                modal
                closeOnDocumentClick
                onClose={this.props.closeAlert}
                contentStyle={{width:'600px',padding:'20px'}}
            >
                <h3>Go To Timeline</h3>
                <p>Please enter the timecode to navigate to the timeline position: </p>

                <form onSubmit={this.editTransaction.bind(this)}>
                    <div className="form-row align-items-center">
                        <div className="row">
                            <div className="col-2">

                                <input className="col-12" value={this.state.hour}
                                       onChange={event => this.setState({ hour: event.target.value })} />
                            </div>:

                            <div className="col-2">

                                <input className="col-12" value={this.state.Minute}
                                       onChange={event => this.setState({ Minute: event.target.value })} />
                            </div>:

                            <div className="col-2">

                                <input className="col-12" value={this.state.second}
                                       onChange={event => this.setState({ second: event.target.value })} />
                            </div>:

                            <div className="col-2">

                                <input className="col-12" value={this.state.fram}
                                       onChange={event => this.setState({ fram: event.target.value })} />
                            </div>
                        </div>
                        <div className="col-auto mt-4">
                            <button type="submit"  className="btn  btn-secondary btn-sm mb-2" >Go</button>
                        </div>
                    </div>
                </form>


            </Popup>
        )
    }
}


TimeLinePop.propTypes = {
    errors: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired,
    transOperation: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    project: state.project,
    errors: state.errors,
    transOperation: state.transOperation,
    editTable: state.editTable
});

export default connect(mapStateToProps, {  goToTimeline })(
    withRouter(TimeLinePop)
);



// WEBPACK FOOTER //
// ./src/components/translations/objects/TimeLinePop.js